import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/signatures')({
  component: Outlet,
})
